import type { HistoryDay } from '@artifax/shared';
import { STATUS_LABEL } from './constants.js';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Updated 42s ago" / "Updated 3m ago" from an ISO timestamp. */
export function updatedAgo(updatedAt: string, now: number): string {
  const secs = Math.max(0, Math.round((now - Date.parse(updatedAt)) / 1000));
  if (secs < 60) return `Updated ${secs}s ago`;
  if (secs < 3600) return `Updated ${Math.floor(secs / 60)}m ago`;
  return `Updated ${Math.floor(secs / 3600)}h ago`;
}

/** Tooltip for a 90-day bar: "Jun 12 · Operational". */
export function dayTooltip(day: HistoryDay): string {
  const d = new Date(`${day.date}T00:00:00Z`);
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()} · ${STATUS_LABEL[day.status]}`;
}

export function formatUptime(uptime90: number): string {
  return `${uptime90.toFixed(2)}%`;
}

/**
 * Build an SVG polyline `points` string for a latency series, scaled to the
 * shared min/max so multiple series share one axis. Mirrors the prototype's
 * 620×180 viewBox geometry.
 */
export function latencyPoints(values: number[], min: number, max: number): string {
  const W = 620;
  const H = 180;
  const pL = 12;
  const pR = 12;
  const pT = 18;
  const pB = 28;
  const span = max - min || 1;
  const n = values.length;
  if (n === 0) return '';
  return values
    .map((v, i) => {
      const x = n === 1 ? pL : pL + (i * (W - pL - pR)) / (n - 1);
      const y = H - pB - ((v - min) / span) * (H - pT - pB);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
}
